export const SPORT_BETTING_MENUS = [
  {
    _id: '63c12012b64f6450d162f8b1',
    component_content_id: '63806c9d40b4a5aea422f06d',
    title: {
      'en-US': 'Digitain sports',
      'th-TH': 'Digitain sports',
      'zh-CN': 'BTI - SBO'
    },
    description: {
      'en-US': 'Digitain sports',
      'th-TH': 'Digitain sports',
      'zh-CN': 'BTI - SBO'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 7645,
    game_provider_id: 67,
    sequence: 1,
    image_desktop_path: {
      'en-US': 'demo/games/sportbooks/image-1-en.png',
      'th-TH': 'demo/games/sportbooks/image-1-th.png',
      'zh-CN': 'demo/games/sportbooks/image-1-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/sportbooks/image-1-en-mobile.png',
      'th-TH': 'demo/games/sportbooks/image-1-th-mobile.png',
      'zh-CN': 'demo/games/sportbooks/image-1-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T09:10:42.541Z',
    updated_at: '2025-03-21T08:45:12.462Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    updatedAt: '2024-08-27T07:29:50.735Z'
  },
  {
    _id: '63c12012b64f6450d162f8b3',
    component_content_id: '63806c9d40b4a5aea422f06d',
    title: {
      'en-US': 'afb',
      'th-TH': 'afb',
      'zh-CN': 'Digitain sports'
    },
    description: {
      'en-US': 'afb',
      'th-TH': 'afb',
      'zh-CN': 'Digitain sports'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 22026,
    game_provider_id: 176,
    sequence: 2,
    image_desktop_path: {
      'en-US': 'demo/games/sportbooks/image-2-en.png',
      'th-TH': 'demo/games/sportbooks/image-2-th.png',
      'zh-CN': 'demo/games/sportbooks/image-2-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/sportbooks/image-2-en-mobile.png',
      'th-TH': 'demo/games/sportbooks/image-2-th-mobile.png',
      'zh-CN': 'demo/games/sportbooks/image-2-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T09:10:42.541Z',
    updated_at: '2025-03-21T08:45:12.679Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    }
  },
  {
    _id: '63c12012b64f6450d162f8b4',
    component_content_id: '63806c9d40b4a5aea422f06d',
    title: {
      'en-US': 'tf',
      'th-TH': 'tf',
      'zh-CN': 'SBO'
    },
    description: {
      'en-US': 'tf',
      'th-TH': 'tf',
      'zh-CN': 'SBO'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 9135,
    game_provider_id: 103,
    sequence: 3,
    image_desktop_path: {
      'en-US': 'demo/games/sportbooks/image-3-en.png',
      'th-TH': 'demo/games/sportbooks/image-3-th.png',
      'zh-CN': 'demo/games/sportbooks/image-3-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/sportbooks/image-3-en-mobile.png',
      'th-TH': 'demo/games/sportbooks/image-3-th-mobile.png',
      'zh-CN': 'demo/games/sportbooks/image-3-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T09:10:42.541Z',
    updated_at: '2025-03-21T08:45:12.863Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    link: {
      'en-US': null,
      'th-TH': null,
      'zh-CN': null
    },
    updatedAt: '2024-08-27T07:29:50.930Z'
  },
  {
    _id: '63c12273b64f6450d162f935',
    component_content_id: '63806c9d40b4a5aea422f06d',
    title: {
      'en-US': 'BTI - SBO',
      'th-TH': 'BTI - SBO',
      'zh-CN': 'SABA sport'
    },
    description: {
      'en-US': 'BTI - SBO',
      'th-TH': 'BTI - SBO',
      'zh-CN': 'SABA sport'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 5900,
    game_provider_id: 60,
    sequence: 5,
    image_desktop_path: {
      'en-US': 'demo/games/sportbooks/image-4-en.png',
      'th-TH': 'demo/games/sportbooks/image-4-th.png',
      'zh-CN': 'demo/games/sportbooks/image-4-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/sportbooks/image-4-en-mobile.png',
      'th-TH': 'demo/games/sportbooks/image-4-th-mobile.png',
      'zh-CN': 'demo/games/sportbooks/image-4-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T09:20:51.916Z',
    updated_at: '2025-03-21T08:45:13.064Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    link: {
      'en-US': null,
      'th-TH': null,
      'zh-CN': null
    },
    updatedAt: '2024-08-27T07:29:51.036Z'
  },
  {
    _id: '63c12012b64f6450d162f8af',
    component_content_id: '63806c9d40b4a5aea422f06d',
    title: {
      'en-US': 'sport',
      'th-TH': 'sport',
      'zh-CN': 'AFB'
    },
    description: {
      'en-US': 'sport',
      'th-TH': 'sport',
      'zh-CN': 'AFB'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 9135,
    game_provider_id: 103,
    sequence: 6,
    image_desktop_path: {
      'en-US': 'demo/games/sportbooks/image-5-en.png',
      'th-TH': 'demo/games/sportbooks/image-5-th.png',
      'zh-CN': 'demo/games/sportbooks/image-5-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/sportbooks/image-5-en-mobile.png',
      'th-TH': 'demo/games/sportbooks/image-5-th-mobile.png',
      'zh-CN': 'demo/games/sportbooks/image-5-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T09:10:42.540Z',
    updated_at: '2025-03-21T08:45:13.179Z'
  }
]
